export const isMobile = (): boolean => {
  return (
    navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i) !== null
  );
};
